import React from 'react';
import { observer } from 'mobx-react';
import {Box} from '@mui/material';
import FormSection from '../../../forms/FormSection';
import FormRow from '../../../forms/FormRow';
import FormColumn from '../../../forms/FormColumn';
import FormTextField from '../../../components/fields/FormTextField';
import CompletionProgressBar from '../../../components/CompletionProgressBar';
import FormSkeleton from '../../../components/FormSkeleton';
import useFeature from '../../../useFeature';
import {useApplication} from "../../../ApplicationProvider";
import PhoneNumberFormRow from "../../../forms/PhoneNumberFormRow";

function CustomerContactPanel({generalFeature}) {
    const application = useApplication();
    const feature = useFeature(() => generalFeature.features['CustomerContactPanelFeature'])


    const isFeatureReady = (feature) => {
        return feature && feature.loaded;
    }

    if (!isFeatureReady(feature)) {
        return (
            <FormSkeleton
                rows={2}
                fieldsPerRow={2}
            />
        );
    }

    const form = feature.form;
    return (
        <Box p={3} display="flex" flexDirection="column" gap={3}>
            <CompletionProgressBar form={form} />
            <FormSection title="Contacto de Cobranzas">
                <FormColumn>
                    <FormRow width={"150%"}>
                        <FormTextField
                            label="Nombre Completo"
                            form={form}
                            fieldName={"collectionsContactName"}
                            onBlur={() => feature.editCustomerContact()}
                        />
                        <FormTextField
                            label="Email"
                            form={form}
                            fieldName={"collectionsContactEmail"}
                            onBlur={() => feature.editCustomerContact()}
                        />
                    </FormRow>
                    <PhoneNumberFormRow form={form}
                                        areaCodeFieldName={'collectionsContactAreaNumber'}
                                        phoneNumber={'collectionsContactPhoneNumber'}
                                        onBlur={() => feature.editCustomerContact()}
                    />
                </FormColumn>
            </FormSection>
            <FormSection title="Contacto de Pedidos">
                <FormColumn>
                    <FormRow width={"150%"}>
                        <FormTextField
                            label="Nombre Completo"
                            form={form}
                            fieldName={"ordersContactName"}
                            onBlur={() => feature.editCustomerContact()}
                        />
                        <FormTextField
                            label="Email"
                            form={form}
                            fieldName={"ordersContactEmail"}
                            onBlur={() => feature.editCustomerContact()}
                        />
                    </FormRow>
                    <PhoneNumberFormRow form={form}
                                        areaCodeFieldName={'ordersContactAreaNumber'}
                                        phoneNumber={'ordersContactPhoneNumber'}
                                        onBlur={() => feature.editCustomerContact()}
                    />
                </FormColumn>
            </FormSection>
        </Box>
    );
}

export default observer(CustomerContactPanel);
